// 视频课程
import learnShowIndex from '@/views/study/learnShow/index'

const zsxxwRoutes = Array.from({ length: 11 }, (_, i) => ({
  path: `learnShow/zsxxw/index${i + 1}`,
  name: `learnShow/zsxxw/Index${i + 1}`,
  component: () => import(`@/views/study/learnShow/zsxxw/index${i + 1}.vue`)
}))

export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'learnShow/index',
      name: 'learnShowIndex',
      component: learnShowIndex
    },
    // 视频课程，开始
    ...zsxxwRoutes
    // 视频课程，结束

  ]
}
